import isDefaultAsset from './is-default-asset';
import { BACKGROUND_IMAGE_ATTRIBUTE } from '../../constants/block-background-attributes';

const handleBlockMediaImageAsFallback = ({
  originalBlockNode,
  destinationBlockNode,
  originalOptionalChildren,
  destinationOptionalChildren,
  backgroundOption,
}) => {
  if (!backgroundOption) return false;

  const originalBlockMedia = originalOptionalChildren.find((el) => el.id === 'block_media');
  const destinationBlockMedia = destinationOptionalChildren.find((el) => el.id === 'block_media');

  if (
    !originalBlockNode.hasAttribute(BACKGROUND_IMAGE_ATTRIBUTE) ||
    destinationBlockNode.hasAttribute(BACKGROUND_IMAGE_ATTRIBUTE) ||
    originalBlockMedia ||
    !destinationBlockMedia
  )
    return false;

  const { querySelector } = destinationBlockMedia;

  const blockMediaNode = destinationBlockNode.querySelector(querySelector);
  if (!blockMediaNode) return false;
  const sourcePicture = blockMediaNode.querySelector('img');
  if (!sourcePicture) return false;

  const src = backgroundOption.origSrc || backgroundOption.values[BACKGROUND_IMAGE_ATTRIBUTE];
  if (isDefaultAsset(src)) return false;
  sourcePicture.setAttribute('src', src);
  return true;
};

export default handleBlockMediaImageAsFallback;
